require('./polyfill.min');
import $ from 'jquery';
import Map from './Map';
import PopUp from "./PopUp";
import Menu from './Menu';
import {Infobox, State} from './Infobox';
import {onClick, copyToClipboard, isMobile, isIe} from './Helper';
import * as proj from "ol/proj";

//<editor-fold desc="general parameter">
/**
 * Private API-Key for the geoservice used for the 'webatlas' layer.
 */
// let apikey = 'e11dae0a-4131-4891-ad39-36e743de89d3';

/**
 * General configuration for the 'webatlas' and 'stimmkreis' layers.
 */
let bayernWMTS = 'https://geoservices.bayern.de/od/wmts/geobasis/v1/1.0.0/WMTSCapabilities.xml';
let bayernKML = 'var/map/stimmkreise_bayern.kml';
let bayernKMLGz = 'var/map/stimmkreise_bayern.kml.gzip';
let projection = 'EPSG:3857';

/**
 * Base urls for the application.
 */
let abgeordnete = 'feature.php';
let tweets = 'tweets.php';

/**
 * Defines the different zoom levels. Currently this has to be done manually. Multiple zoom levels makes the map slow
 * and introduces more data transfer between server and client. Therefore one should aim to keep the number of zoom
 * levels as small as possible.
 * Example: [1,7,10] => 1->7 & 7->10 & 10->maxZoom
 */
let zoom_levels = [1];

(function (w) {
    w.URLSearchParams = w.URLSearchParams || function (searchString) {
        const self = this;
        self.searchString = searchString;
        self.get = function (name) {
            const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
            if (results == null) {
                return null;
            } else {
                return decodeURI(results[1]) || 0;
            }
        };
    }
})(window)

/**
 * Parameter bag for url parameters.
 */
let parameters = new URLSearchParams(window.location.search);

/**
 * Takes id and type from url parameters and automatically loads infobox. To prevent this simply change id and type to
 * null permanently.
 */
let id = parameters.get('id'); //null;
let type = parameters.get('type'); //null;

/**
 * Define some additional behaviour.
 * 'clipboard' toggles whether or not coordinates/ids will be copied when singleclicking or dblclicking on various map
 * elements.
 * 'empty' toggles whether or not the application should load 'abgeordnete'.
 */
let clipboard = false; //parameters.get('clipboard');
let empty = false; //parameters.get('empty');

/**
 * Whether or not the application should ignore if the user is in a secure context. Only put this on true during
 * development!
 */
let ignoreSecureContext = false;

/**
 * Whether or not the application should be shown in social media mode.
 */
let twitter_mode = true;
//</editor-fold>

//<editor-fold desc="functional elements">
/**
 * Enables general map functionality.
 */
let map = new Map({
    target: document.getElementById('map'),
    projection: projection,
    extent: [500000, 5500000, 2100000, 7020000],
    zoom: 6,
    minZoom: 6,
    maxZoom: 20
});

/**
 * Enables general menu functionality.
 */
let menu = new Menu({
    container: 'side-menu',
    openButton: 'side-menu-open',
    closeButton: 'side-menu-close',
    tabs: ['fraktionen', 'wahlkreise', 'stimmkreise']
});

/**
 * Enables general infobox functionality.
 */
let infobox = new Infobox({
    container: 'infobox',
    wheel: 'infobox-wheel',
    content: 'infobox-content',
    closeButton: 'infobox-close',
    mapOverlay: 'map-overlay',
    map: map,
    menu: menu,
    img_size: {
        portrait: [12, 18],
        landscape: [8, 12]
    },
    twitter_mode: twitter_mode
});

/**
 * Enables general popup functionality.
 */
let popup = new PopUp({
    target: document.getElementById('popup'),
    offset: {
        x: 0,
        y: 14
    },
    margin: {
        left: 1.75,
        right: 0,
        top: 0,
        bottom: 1.75
    },
    map: map,
});

/**
 * Necessary to enable the menu to hide the infobox in mobile context.
 */
menu.infobox = infobox;
//</editor-fold>

//<editor-fold desc="loading the map">
/**
 * If map should be displayed as empty, skip one load stage (because 'abgeordnete' do not need to be loaded).
 */
let pendingLoadStages = empty ? 2 : 3;

/**
 * Gets called each time a load stage is completed and adjusts pendingLoadStages. When pendingLoadStages reaches 0,
 * remove loading screen and center on id+type if specified.
 */
let onLoadStageComplete = function () {
    pendingLoadStages--;

    if (pendingLoadStages === 0) {
        $(".loading").fadeOut(1000);

        if (id && type) {
            if (type === 'abgeordneter') infobox.state(type, id, map.getAbgeordnetenKeys(false), null);
            if (type === 'stimmkreis') infobox.state(type, id, Object.keys(map.stimmkreise), null);
            if (type === 'wahlkreis') infobox.state(type, id, Object.keys(map.wahlkreise), null);
        }
    }
};

/**
 * Load 'webatlas' and 'stimmkreise'. After each load was successful, call onLoadStageComplete.
 */
let mapPromise = map.loadCapabilities(bayernWMTS, onLoadStageComplete)
    .then(function () {
        return map.loadStimmkreise(bayernKML, onLoadStageComplete)
    });

/**
 * If map should display 'abgeordnete', load 'abgeordnete'. After successful load, load 'tweets' for each
 * 'abgeordneter'. Lastly call onLoadStageComplete.
 * Additionally refresh 'tweets' every 5 minutes.
 */
if (!empty) {
    mapPromise = mapPromise.then(function () {
        return map.loadFeatures(abgeordnete, zoom_levels, function () {
            map.loadTweets(tweets, onLoadStageComplete);
        })
    });

    setInterval(function () {
        map.loadTweets(tweets, null)
    }, 300000); // every 5 minutes
}
//</editor-fold>

//<editor-fold desc="general event listeners">
/**
 * Clicking on the map overlay the infobox should close.
 */
onClick('#map-overlay', function () {
    infobox.close()
});

/**
 * Clicking on the custom zoom buttons should trigger the original zoom buttons.
 */
onClick('#zoom-in', function () {
    $('.ol-zoom-in').click()
});
onClick('#zoom-out', function () {
    $('.ol-zoom-out').click()
});

/**
 * Clicking on an element with id 'modal' should open the info modal.
 */
onClick('#toggle-info-modal', function () {
    $(".modal.info").addClass("open")
});

/**
 * Clicking on the close icon on any modal should close said modal and additionally stop any running video by clearing
 * the 'iframecontainer'.
 */
onClick('.modal .icon-close', function () {
    $(".modal").removeClass("open");
    $(".iframecontainer").html("");
});

/**
 * Clicking on the map layer toggle buttons toggles between the satdop and webatlas layer. (uncomment to activate)
 */
onClick('#toggle-map-mode', function () {
    switch (true) {
        case map.isActiveLayerSatdop():
            map.showWebatlasLayer();
            $('#webatlas-mode').hide();
            $('#satdop-mode').show();
            break;
        case map.isActiveLayerWebatlas():
            map.showSatdopLayer();
            $('#satdop-mode').hide();
            $('#webatlas-mode').show();
            break;
    }
});

/**
 * Clicking on the checkbox toggles between twitter mode and normal mode.
 */
onClick('#toggle-twitter-mode', function () {
    twitter_mode = !this.checked;

    infobox.twitter_mode = twitter_mode;

    if (infobox.current) {
        let state = new State(map, infobox.current, infobox.current).setTwitterMode(twitter_mode);
        state.flyto_target = false;
        infobox.ajax(state, null);
    }
});

$().ready(function () {
    $('#toggle-twitter-mode').prop("checked", !twitter_mode);
});
//</editor-fold>

//<editor-fold desc="handy callbacks often used by the following event listeners">
/**
 * Opens video modal for a given video url and fills the 'iframecontainer' with an iframe for said video.
 */
let openVideo = function (url) {
    $(".modal.video").addClass("open");
    $(".iframecontainer").html("<iframe id='video' src='" + url + "' width='640' height='360' allow='autoplay; fullscreen' allowfullscreen></iframe>");
};
//</editor-fold>

//<editor-fold desc="event listeners for infobox content">
/**
 * These are the element selectors and the corresponding functions which will be executed on a click event.
 * All event listeners will be added with every newly opened infobox so every element in said infobox has the correct
 * event listeners at any moment.
 */
infobox.registerEvents({
    '.back-infobox': function () {
        infobox.back();
    },
    '.load-infobox': function () {
        infobox.state(
            this.dataset.type,
            this.dataset.id,
            (this.dataset.filter !== undefined) ? JSON.parse(this.dataset.filter) : [],
            null);
    },
    '.icon-list': function () {
        infobox.list();
    },
    '.icon-list-cards': function () {
        infobox.cards();
    },
    '#player': function () {
        openVideo(this.dataset.url);
    },
    '.twitterButton': function (event) {
        event.preventDefault();
        scrollToTweets();
    }
});
//</editor-fold>

//<editor-fold desc="event listeners for the map">
/**
 * On a 'singleclick' depending on what was clicked the following behaviour should occur:
 * click on video: the video of an 'abgeordneter' is opened, map view does not change
 * click on tweet: the infobox of an 'abgeordneter' is opened and scrolls down to tweets, map view centers on 'abgeordneter'
 * click on text/image/pin: the infobox of an 'abgeordneter' is opened, map view centers on 'abgeordneter'
 * click on stimmkreis: the infobox of a 'stimmkreis' is opened, map view centers on 'stimmkreis'
 * click somewhere else: infobox and popup gets closed
 *
 * If 'clipboard'==True: copies coordinates of click to clipboard.
 */
map.on('singleclick', function (evt) {
    evt.preventDefault();

    let feature = map.getFeatureAtPixel(evt.pixel, 'singleclick');

    switch (true) {
        case feature.video:
            if (map.abgeordnete[feature.id].abgeordneter.video !== null) {
                openVideo(map.abgeordnete[feature.id].abgeordneter.video);
            }
            break;
        case feature.tweet && !twitter_mode:
            infobox.state('abgeordneter', feature.id, map.getAbgeordnetenKeys(false), null); // TODO: mayby redirect to twitter?
            break;
        case feature.abgeordneter:
            infobox.state('abgeordneter', feature.id, map.getAbgeordnetenKeys(false), null);
            break;
        case feature.stimmkreis:
            infobox.state('stimmkreis', feature.id, Object.keys(map.stimmkreise), null);
            break;
        default:
            infobox.close();
            popup.close();
    }

    if (clipboard) {
        copyToClipboard(proj.getTransform(projection, 'EPSG:4326')(map.map.getCoordinateFromPixel(evt.pixel)));
    }
});

/**
 * On a 'dblclick' depending on what was clicked the following behaviour should occur:
 * click on video: the video of an 'abgeordneter' is opened, map view does not change
 * click on tweet: the infobox of an 'abgeordneter' is opened and scrolls down to tweets, map view centers on 'abgeordneter'
 * click on text/image/pin: the infobox of an 'abgeordneter' is opened, map view centers on 'abgeordneter'
 * click on stimmkreis: the infobox of the corresponding 'wahlkreis' is opened, map view centers on 'wahlkreis'
 * click somewhere else: infobox and popup gets closed
 *
 * If 'clipboard'==True: copies id of clicked element to clipboard.
 */
map.on('dblclick', function (evt) {
    evt.preventDefault();

    let feature = map.getFeatureAtPixel(evt.pixel, 'dblclick');

    switch (true) {
        case feature.video:
            if (map.abgeordnete[feature.id].abgeordneter.video !== null) {
                openVideo(map.abgeordnete[feature.id].abgeordneter.video);
            }
            break;
        case feature.tweet && !twitter_mode:
            infobox.state('abgeordneter', feature.id, map.getAbgeordnetenKeys(false), null); // TODO: mayby redirect to twitter?
            break;
        case feature.abgeordneter:
            infobox.state('abgeordneter', feature.id, map.getAbgeordnetenKeys(false), null);
            break;
        case feature.stimmkreis:
            infobox.state('wahlkreis', feature.id[0], Object.keys(map.wahlkreise), null);
            break;
        default:
            infobox.close();
            popup.close();
    }

    if (clipboard) {
        copyToClipboard(feature.id);
    }
});

/**
 * On a 'pointermove' depending on what the pointer points to, the following behaviour should occur:
 * point on tweet: a popup with the last 'tweet' of the 'abgeordneter' is opened
 * point somewhere else: popup gets timeout after which it will close
 */
map.on('pointermove', function (evt) {
    evt.preventDefault();

    let feature = map.getFeatureAtPixel(evt.pixel, 'pointermove');

    if (feature.tweet && !isMobile()) {
        popup.clearTimeout();

        popup.open(
            feature.feature,
            map.abgeordnete[feature.id].tweets['overlay'],
            function () {
                onClick('.load-infobox', function () {
                    infobox.state(this.dataset.type, this.dataset.id, map.getAbgeordnetenKeys(false), null)
                });
            });
    } else {
        if (!popup.is(":hover")) {
            popup.timeoutAfter(500);
        }
    }
});

/**
 * On a 'movestart' the popup will be closed. This includes 'zoom' events and is necessary due to the
 * positioning of the popup which needs to be calculated for each zoom level.
 */
map.on('movestart', function () {
    popup.close();
});
//</editor-fold>

//<editor-fold desc="event listeners for the popup">
/**
 * While hovering over the popup, the timeout after which the popup will close itself will be reset.
 */
popup.on('mouseover', function () {
    popup.clearTimeout();
});
//</editor-fold>

//<editor-fold desc="event listeners for the window">
let isFirefox = typeof InstallTrigger !== 'undefined';
let hash_block = window.location.href.indexOf("#") > -1;

/**
 * Changes hash of the url immediately when opening this webpage in order for the event listener to get called.
 * Otherwise when loading the page the hash of the url might not be changed until one selects an 'abgeordneter' which
 * would lead to inconsistent behaviour when trying to close the infobox of an 'stimmkreis' or 'wahlkreis' via the
 * browsers back button.
 */
if (isFirefox) {
    if (hash_block) {
        hash_block = false;
        window.history.pushState(null, null, '.');
        hash_block = false;
    }

    window.location.hash = "";
} else {
    if (hash_block) {
        window.history.pushState(null, null, '.');
    }

    window.history.pushState(null, null, './#');
}

/**
 * When pressing the back button of the browser, instead of going back, closes the infobox, popup and menu and adds a
 * '#' at the end of the url. This leads to the user being unable to accidentally leave the page with the use of the
 * browser back button.
 */
window.addEventListener('hashchange', function () {
    switch (true) {
        case infobox.isOpen():
        case menu.isOpen():
            infobox.close();
            menu.close();

            hash_block = false;
            if (isFirefox) {
                window.location.hash = "";
            } else {
                window.history.pushState(null, null, './#');
            }
            break;
        case hash_block:
            window.history.back();
            break;
        default:
            hash_block = true;
    }

    if (!isFirefox && window.location.href.indexOf("#") === -1) {
        window.history.back();
    }
});

window.addEventListener('popstate', function () {
    if (!isFirefox) {
        hash_block = true;
        window.location.hash = "";
    }
}, false);

/**
 * On a change in window size, the size of the infobox needs to be adjusted. This is especially important when dealing
 * with the mobile view of the webpage.
 */
window.addEventListener('resize', function () {
    infobox.resize();
});

/**
 * Fix the infobox-close button position when scrolled past the window header.
 */
window.addEventListener('scroll', function () {
    if (window.scrollY >= $('header')[0].scrollHeight) {
        $('#infobox-close').addClass('btn-fixed');
    } else {
        $('#infobox-close').removeClass('btn-fixed');
    }
});
//</editor-fold>

//<editor-fold desc="additional functionality">
/**
 * Code for geolocation based on position (only works in bavaria and in a secure context window). If a location is
 * found and lays in one of the 'stimmkreise' the map is centered on that position, otherwise the map will center on
 * the middle of the map and zoom out to show the whole map.
 * If either the geolocation service is not found or the window is not in a secure context the golocation button will
 * be hidden.
 */
if (navigator.geolocation && (window.isSecureContext || ignoreSecureContext)) {
    onClick('#location', function () {
        let showPosition = function (position) {
            position = proj.getTransform('EPSG:4326', projection)([position.coords.longitude, position.coords.latitude]);

            let intersects = false;

            $.each(map.stimmkreise, function () {
                if (this.getGeometry().intersectsCoordinate(position)) {
                    intersects = true;

                    return false;
                }
            });

            if (intersects) {
                map.flyTo(position, 17);
            } else {
                map.flyTo(map.options.center, map.options.zoom);
            }
        };

        let denied = function () {
            map.flyTo(map.options.center, map.options.zoom);
        };

        navigator.geolocation.getCurrentPosition(showPosition, denied);
    });
} else {
    $('#location').hide();
}

if (isIe()) {
    $('body').addClass('internetexplorer')
}
//</editor-fold>
